// The bounds the pay contract puts on `cdata`, checked on the client as well
// as the server so a payer is told which answer is too long instead of losing
// the whole submission to a 400.
//
// ⛔ A field over the bound is REFUSED, never truncated. Silently shortening a
// payer's answer to make it fit is a data-loss defect wearing a bounds check.

export const MAX_CDATA_PROPERTIES = 20;
export const MAX_CDATA_VALUE_CODE_POINTS = 500;

// The server counts Unicode CODE POINTS, and JavaScript's `.length` counts
// UTF-16 units -- so a string of 300 emoji measures 600 to `.length` and 300
// to the server. Counting the wrong one rejects an answer the server would
// have accepted, on a field the payer cannot shorten without deleting content
// they were asked for.
export const codePointLength = (value: string): number =>
  Array.from(value).length;

export const isWithinValueBound = (value: string): boolean =>
  codePointLength(value) <= MAX_CDATA_VALUE_CODE_POINTS;

// The ids whose answers are too long, in declaration order, so the caller can
// name them rather than saying only that something is wrong.
export const oversizedCdataValues = (
  values: Record<string, string>
): string[] =>
  Object.entries(values)
    .filter(([, value]) => !isWithinValueBound(value))
    .map(([fieldId]) => fieldId);

export const isWithinPropertyBound = (
  values: Record<string, string>
): boolean => Object.keys(values).length <= MAX_CDATA_PROPERTIES;
